import { ApolloClient } from 'apollo-client'
import { createUploadLink } from 'apollo-upload-client'
import { ApolloLink, concat } from 'apollo-link'
import { InMemoryCache } from 'apollo-cache-inmemory'
import store from './store'
import { removeTypename } from './helpers'
import { getJwt } from '../modules/admin/selectors'

const httpLink = createUploadLink({
  uri: process.env.REACT_APP_APOLLO_URI,
})

const mutationLink = new ApolloLink((operation, forward) => {
  const token = getJwt(store.getState())
  const context = operation.getContext()
  operation.setContext({
    headers: {
      ...context.headers,
      authorization: token ? `Bearer ${token}` : '',
    },
  })

  if (operation.variables) {
    // eslint-disable-next-line
    operation.variables = removeTypename(operation.variables)
  }

  return forward(operation)
})

export default new ApolloClient({
  link: concat(mutationLink, httpLink),
  cache: new InMemoryCache(),
})



// WEBPACK FOOTER //
// ./src/utils/graphqlClient.js